import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import "./index.css";
import "antd/dist/antd.css";
import App from "./app/Index";
import * as serviceWorker from "./serviceWorker";
import "./i18n";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { persistor } from "redux/store";
import store from "redux/store";

// src/config/antdMessageConfig.js
import { message } from "antd";

message.config({
  top: 20,
  duration: 5,
  maxCount: 3,
});


ReactDOM.render(
  <>
    <Suspense fallback={<span>Loading...</span>}>
      <Provider store={store}>
        <PersistGate persistor={persistor}>
          <App />
        </PersistGate>
      </Provider>
    </Suspense>
  </>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
